import styled from 'styled-components';

// INDEX 페이지
export const MenuStockManageListWrapper = styled.div`
  display: flex;
  font-size: 16px;

  .style-div {
    height: 137px;
  }

  @media screen and (max-width: 1000px) {
    flex-direction: column;

    .style-div {
      display: none;
    }
  }
`;

export const MenuStockManageBoardWrapper = styled.div`
  width: 100%;

  .menu-salesStats-info {
    margin-top: 20px;
    width: 95%;
    margin-left: 20px;
    margin-bottom: 10px;
  }

  .ele2 {
    position: sticky;
    top: 0;
    background-color: #f7f7f7;
    height: 120px;
    width: 95%;
    display: inline-block;
    margin-left: 20px;
    z-index: 10;
  }

  .menu-template-edit-modal-header {
    background-color: #ffffff;
    height: 60px;
  }

  .menu-header-table {
    float: left;
    width: 100%;
    margin-top: 20px;
  }

  .menu-table-header {
    height: 45px;
    background-color: #666666;
  }
  .custom-checkbox {
    width: 20px;
    height: 20px;
    appearance: none;
    -webkit-appearance: none;
    border: 2px solid #5cb85c;
    border-radius: 3px;
    background-color: transparent;
    position: relative;
    cursor: pointer;
    outline: none;

    &:checked {
      background-color: #5cb85c;
    }

    &:checked::after {
      content: '✓';
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      color: white;
      font-size: 22px;
      font-weight: bold;
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }

    &:focus {
      outline: none;
      box-shadow: none;
    }
  }

  .menu-status-box {
    width: 90px;
    text-align: center;
  }

  .menu-stockManage-table {
    float: left;
    width: 95%;
    margin-left: 20px;
    margin-bottom: 30px;
    border: 1px solid #444444;
    border-collapse: collapse;
  }

  .menu-stockManage-table th,
  td {
    border: solid 1px rgba(0, 0, 0, 0.1);
    border-collapse: collapse;
  }

  .scroll-box {
    @media screen and (max-width: 1000px) {
      height: 550px;
      overflow: scroll;
    }
  }

  .btn:focus,
  .btn:active,
  .btn.active {
    outline: none !important;
    box-shadow: none !important;
    border: none !important;
  }

  /* Modal positioning fix */
  .ant-modal {
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    margin: 0 !important;
    padding-bottom: 0 !important;
  }

  .menu-table-content {
    padding: 10px;
    border: 1px solid #ddd;
    text-align: center;
    vertical-align: middle;
  }
`;
